"use strict";

exports.__esModule = true;
exports.isValidNoop = isValidNoop;
exports.NOOP = void 0;

/**
 *
 * @param {function} noop - Function to validate
 * @returns {boolean} - True if valid, false if invalid
 */
function isValidNoop(noop) {
  return noop === NOOP;
}

var NOOP = function NOOP() {};

exports.NOOP = NOOP;